import React from "react";
import Header from "./Header";
import PqrsdApprovalQueue from "../pqrsd/PqrsdApprovalQueue";

export default function LayoutPqrsdApprovals() {
  return (
    <>
      <Header />
      <PqrsdApprovalQueue />
    </>
  );
}
